import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { API, SERVER_DOMAIN } from "../../assets/staticData";

export default function SelectLang({ lang, setLang }) {
  const [langs, setLangs] = React.useState([]);

  const handleChange = (event) => {
    setLang(event.target.value);
  };

  let userToken = localStorage.getItem("userToken");

  const headers = {
    Authorization: `Bearer ${userToken}`,
  };

  React.useEffect(() => {
    async function getData() {
      fetch(`${API}/languages?populate=*`, {
        headers,
        method: "GET",
      }).then(async (res) => {
        const respone = await res.json();
        setLangs(respone.data);
      });
    }

    getData();
  }, []);

  return (
    <FormControl
      sx={{
        minWidth: 300,
        width: "90%",
        textAlign: "start",
      }}
      size="small"
    >
      <Select
        value={lang}
        onChange={handleChange}
        displayEmpty
        inputProps={{ "aria-label": "Without label" }}
      >
        <MenuItem value="" disabled>
          Select Language
        </MenuItem>
        {langs &&
          langs.map((item, index) => (
            <MenuItem key={index} value={item?.attributes?.language}>
              <img
                style={{ width: 25, marginRight: 7 }}
                src={
                  SERVER_DOMAIN + item?.attributes?.icon?.data?.attributes?.url
                }
              />
              {item?.attributes?.language}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}
